import ItemStockScreen from './item_stock/index';

//item
import ItemScreen from './items/index';
import ItemCreateScreen from './items/create'
import ItemUpdateScreen from './items/update'
import ItemDetailScreen from './items/detail'

// stockmovement
import StockmovementScreen from './stockmovement/index';
import StockmovementCreateScreen from './stockmovement/create';
import StockmovementUpdateScreen from './stockmovement/update';
import StockmovementDetailScreen from './stockmovement/detail';

// stockopname
import StockopnameScreen from './stockopname/index';
import StockopnameCreateScreen from './stockopname/create';
import StockopnameUpdateScreen from './stockopname/update';
import StockopnameDetailScreen from './stockopname/detail';

const routes = [
  {
    path: '/inventory/item-stock',
    component: ItemStockScreen,
  },
  {
    path: '/inventory',
    component: ItemScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.item',
    params: {},
  },
  {
    path: '/inventory/stockmovement',
    component: StockmovementScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.stockmovement',
    params: {},
  },
  {
    path: '/inventory/stockopname',
    component: StockopnameScreen,
  },

  // stockopname
  {
    path: '/inventory/stockopname/create',
    component: StockopnameCreateScreen,
    action: ['manage'],
    service: 'nvo.wms.stockopname',
  },
  {
    path: '/inventory/stockopname/:id',
    component: StockopnameDetailScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.stockopname',
  },
  {
    path: '/inventory/stockopname/:id/update',
    component: StockopnameUpdateScreen,
    action: ['manage'],
    service: 'nvo.wms.stockopname',
  },

  // stockmovement
  {
    path: '/inventory/stockmovement/create',
    component: StockmovementCreateScreen,
    action: ['manage'],
    service: 'nvo.wms.stockmovement',
  },
  {
    path: '/inventory/stockmovement/:id',
    component: StockmovementDetailScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.stockmovement',
  },
  {
    path: '/inventory/stockmovement/:id/update',
    component: StockmovementUpdateScreen,
    action: ['manage'],
    service: 'nvo.wms.stockmovement',
  },

  // item
  {
    path: '/inventory/create',
    component: ItemCreateScreen,
    action: ['manage'],
    service: 'nvo.wms.item',
  },
  {
    path: '/inventory/:id',
    component: ItemDetailScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.item',
  },
  {
    path: '/inventory/:id/update',
    component: ItemUpdateScreen,
    action: ['manage'],
    service: 'nvo.wms.item',
  },
];

export default routes;
